import React from "react";

const MessageDisplay = ({ message }) => {
  if (!message) return null; // Don't render anything if no message

  return (
    <div className="mt-1 mb-3 text-blue-500">
      <p>{message}</p>
    </div>
  );
};

export default MessageDisplay;
